import { render, staticRenderFns } from "./SelectBusinessPayrollDetailsAction.vue?vue&type=template&id=91eed2d0&scoped=true&"
import script from "./SelectBusinessPayrollDetailsAction.vue?vue&type=script&lang=ts&"
export * from "./SelectBusinessPayrollDetailsAction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91eed2d0",
  null
  
)

export default component.exports